import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';
import { Location } from '@angular/common';

/** Service file */
import { AssignProService } from './assignPro.service';
import { SolutionFormService } from '../solutionForm/solutionForm.service';

/** Local component */

/** Local files */
import { assignPro } from '../../utils/e-commerce/assignPro';
import { orders } from '../../utils/e-commerce/orders';
import { CommonOrdersService } from '../orders/commonOrders.service';

@Component({
    selector: 'assign-pro',
    templateUrl: './assignPro.component.html',
    styleUrls: ['./assignPro.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AssignProComponent implements OnInit {

    commonValues: any;
    ordersValues = orders;
    currentOrderId: any;
    currentView: any;
    allStatus: OrderStatus[];
    orderIdSubscription: Subscription;
    viewChangeSubscription: Subscription;
    orderStatusSubscription: Subscription;
    assignAnotherProChangedSubscription: Subscription;

    orderHistory: String;

    isLoading: boolean = false;

    constructor(
        public location: Location,
        /** Service file */
        public assignProService: AssignProService,
        public solutionFormService: SolutionFormService,
        public commonOrdersService: CommonOrdersService,
    ) {
        this.commonValues = assignPro;
        this.assignProService.GetAllProUsers('Pro');
        this.commonOrdersService.listOfStatus.subscribe((statusRes) => {
            this.allStatus = statusRes.length > 0 ? statusRes : [];
        });
    }

    ngOnInit() {

        /** Status subscription */
        this.orderStatusSubscription =
            this.assignProService.orderStatus.subscribe(response => {

                
                
                if (!response.loading) {

                    /** Set current View */
                    this.currentView = response.details.statusId == this.allStatus[3].statusId ? null : 'afterAssign';
                    this.isLoading = false;
                }

            });

        /** Order id subscription */
        this.orderIdSubscription =
            this.assignProService.currentOrdeId.subscribe(id => {
                this.currentOrderId = id;
            })

        /** View subscription */
        this.viewChangeSubscription =
            this.assignProService.viewChanged.subscribe(view => {

                this.currentView = view;
                this.getOrderDetails(this.currentOrderId);
            }, () => {
            })

        /** Assign pro view subscription */
        this.assignAnotherProChangedSubscription =
            this.assignProService.assignAnotherProChanged.subscribe(view => {         
                this.currentView = view;
            })

    }

    getOrderDetails(id) {

        this.isLoading = true;
        /** Check order assigned to pro or not */
        this.assignProService.getOrderDetails(id)
            .then((data: any) => {
                this.isLoading = false;
            })
            .catch(() => {
                this.isLoading = false;
            })
    }

    goback() {
        this.location.back();
    }
    ngOnDestroy() {
        this.orderStatusSubscription.unsubscribe();
        this.orderIdSubscription.unsubscribe();
        this.viewChangeSubscription.unsubscribe();
        this.assignAnotherProChangedSubscription.unsubscribe()
    }

}
export interface OrderStatus {    
    statusId: number;
    statusName: string;
    displayStatus: string;
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/assignPro/assignPro.component.ts